import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-alt px-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-3xl border border-line bg-white p-10 text-center">
        <XCircle className="mx-auto h-14 w-14 text-muted-foreground" />
        <h1 className="mt-6 font-display text-2xl font-bold text-ink">Checkout canceled</h1>
        <p className="mt-2 text-muted-foreground">No worries — your card wasn't charged. You can pick up where you left off any time.</p>
        <div className="mt-8 flex flex-col gap-3">
          <Link to="/products" data-testid="cancel-back" className="rounded-full bg-crimson px-8 py-3 font-bold text-white hover:bg-crimson-hover">
            Back to iPhones
          </Link>
          <Link to="/apply" data-testid="cancel-lease" className="rounded-full border border-ink px-8 py-3 font-bold text-ink hover:bg-ink hover:text-white">
            Lease instead
          </Link>
        </div>
      </div>
    </div>
  );
}
